module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel05_1280_1280_vi-999a709dad653c6b33c2010d56664e09.jpg";